module.exports = __webpack_public_path__ + "static/media/Ex5-S1.2aa770a4.PNG";